import { STATUS } from "@/lib/calc";

const HealthBreakdown = ({ metrics }) => {
  const total = metrics?.total_clients || 0;
  const rows = [
    { key: "on_track", count: metrics?.on_track_count || 0 },
    { key: "close_to_limit", count: metrics?.close_to_limit_count || 0 },
    { key: "losing_money", count: metrics?.losing_money_count || 0 },
  ];

  return (
    <div className="bg-white border border-[#E4DFD2] rounded-xl p-6" data-testid="health-breakdown">
      <div className="flex items-center justify-between mb-1">
        <div>
          <div className="text-[11px] tracking-[0.08em] uppercase font-semibold text-[#69747C]">
            Retainer Health
          </div>
          <div className="font-display text-lg font-semibold text-[#1F2326]">
            {total} retainer{total === 1 ? "" : "s"} tracked
          </div>
        </div>
      </div>

      <div className="flex h-2 w-full mt-4 rounded-full overflow-hidden bg-[#F0EADA]" data-testid="health-bar">
        {rows.map((r) => {
          const pct = total > 0 ? (r.count / total) * 100 : 0;
          if (pct === 0) return null;
          return (
            <div
              key={r.key}
              className={STATUS[r.key].fill}
              style={{ width: `${pct}%` }}
              title={`${STATUS[r.key].label}: ${r.count}`}
            />
          );
        })}
      </div>

      <div className="mt-5 space-y-3">
        {rows.map((r) => (
          <div key={r.key} className="flex items-center gap-3" data-testid={`health-row-${r.key}`}>
            <span className={`w-2.5 h-2.5 rounded-full ${STATUS[r.key].fill}`} />
            <div className="flex-1 flex items-baseline justify-between">
              <div>
                <div className="text-sm font-medium text-[#1F2326]">{STATUS[r.key].label}</div>
                <div className="text-xs text-[#69747C]">{STATUS[r.key].description}</div>
              </div>
              <div className="font-display text-2xl font-semibold text-[#1F2326] tabular-nums">
                {r.count}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthBreakdown;
